export enum TableSubmissionStatus {
  Completed = 'Complete',
  InProgress = 'In progress',
  NotRequired = 'Not required',
  NotStarted = 'Not started',
}
